import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import { useRouter } from 'next/router';

import {
    Avatar,
    Badge,
    Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { RequestNextApi } from '../../api/Request';
import { getCookie } from '../../utils/cookieHandle';
import { communityNavigation } from '../../navigation/community';
import { ShowNotification } from '../../utils/notification/snackbarUtils';
//import { PusherContext } from '../Context/pusherContext';
import Link from 'next/link';

const StatusDiv = styled('div')(({ theme }) => ({
    width: 18,
    height: 18,
    border: `2px solid ${theme.palette.background.paper}`,
    borderRadius: '50%'
}));

export default function MemberConnections({ banner }) {
   // const { state: pusherContext } = useContext(PusherContext);

    const [connections, setConnections] = useState();
    const [requestedConnections, setRequestedConnections] = useState();

    const router = useRouter();

    const connectionsFetch = async () => {
        try {
            const res = await RequestNextApi.post('/user/user-fetch-connections',
                {
                    jwtToken: getCookie('jwt-token')
                }
            );
            if (res.data && res.data.success) {
                let result = res.data.connections.filter(e => e.status === 'Connected');
                setConnections(result);

                // if (pusherContext?.onlineUsers?.length > 0) {
                //     setConnections(sortByOnlineStatus(result));
                // } else {
                //     setConnections(result);
                // }
                result = res.data.connections.filter(e => e.status === 'They Requested');
                setRequestedConnections(result);
            } else {
                ShowNotification.error(res.data.message);
            }
        } catch (error) {
            ShowNotification.error('Connection fetch failed');
        }
    };

    // sort connections list by their online status
    // const sortByOnlineStatus = (data) => {
    //     const connections = data.map(item => {
    //         return {
    //             ...item,
    //             online: pusherContext.onlineUsers.includes(String(item.userId)) ? true : false
    //         }
    //     });
    //     connections.sort((a, b) => b.online - a.online);
    //     return connections;
    // }

    useEffect(() => {
        connectionsFetch();
    }, []);

    // useEffect(() => {
    //     if (pusherContext?.onlineUsers?.length > 0 && connections?.length > 0) {
    //         const sortedConnections = sortByOnlineStatus(connections);
    //         setConnections([...sortedConnections]);
    //     }
    // }, [pusherContext?.onlineUsers])

    const handleClickConnections = () => {
        router.push(`${communityNavigation.connections.href}`);
    };

    return (
      <>
          <div className='bg-secondary-500 py-5 grid grid-cols-1 lg:grid-cols-2 gap-4 items-center' style={{marginLeft: '-2rem', marginRight: '-2rem'}}>
              <div className='lg:mx-12 flex justify-center lg:justify-start px-2'>
                  <div>
                      <Badge color="error" badgeContent={requestedConnections?.length}>
                          <div
                            className='rounded-lg text-white border-2 border-white border-solid text-xl p-3 w-fit cursor-pointer'
                            onClick={handleClickConnections}
                          >
                              Manage Member Connections
                          </div>
                      </Badge>
                  </div>
              </div>
              {/* show 5 avatar in max */}
              <div className='grid grid-cols-2 sm:grid-cols-6 gap-4'>
                  {connections && (
                    connections.map((item, index) => {
                        if (index < 5) {
                            return (
                              <div key={index} className='flex items-center flex-col p-1 text-center'>
                                  <Badge
                                    overlap='circular'
                                    anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                                    // badgeContent={
                                    //     <StatusDiv
                                    //     //  className={`${pusherContext?.onlineUsers?.includes(String(item.userId)) ? 'bg-green-400' : 'bg-gray-200'}`}
                                    //     />
                                    // }
                                  >
                                      <Avatar
                                        alt="Travis Howard"
                                        sx={{width: 56, height: 56}}
                                        src={`${process.env.S3_URL}/user-profile-pics/${item?.profilePic}`}
                                      >
                                          {item.firstName.charAt(0)}{item.lastName.charAt(0)}
                                      </Avatar>
                                  </Badge>
                                  <Typography
                                    component='div'
                                    variant="caption"
                                    className='text-white'
                                  >
                                      {item.firstName} {item.lastName}
                                  </Typography>
                              </div>
                            )
                        }
                    })
                  )}
                  {connections && connections.length > 6 && (
                    <Typography
                      component='div'
                      variant="h4"
                      className='text-white self-center'
                    >
                        +{connections.length - 5}
                    </Typography>
                  )}
              </div>
          </div>

          {banner}
      </>
    )
}
